import { post, get } from '../utils/fetch';

// 首页的API
export default class IndexService {
    // 顶部banner图列表
    static fetchBannerList(params) {
        return post('/api/v1/dynamic/query', params)
    }

    // 业务板块
    static fetchBusinessUnitList(params) {
        return post('/api/v1/dynamic/query', params)
    }

    // 核心产品
    static fetchCoreProductList(params) {
        return post('/api/v1/dynamic/query', params)
    }
}




// WEBPACK FOOTER //
// ./src/api/indexService.js